import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { LocalStorageService } from 'ngx-webstorage';
import { Router } from '@angular/router';
import { forgotPwdComponent } from '../forgot-pwd/forgot-pwd.component';
import { signupComponent } from '../signup/signup.component';
import { AuthService } from '../../../../services/auth.service';
var loginComponent = /** @class */ (function () {
    function loginComponent(activeModal, modalService, authAPIs, router, localSt) {
        this.activeModal = activeModal;
        this.modalService = modalService;
        this.authAPIs = authAPIs;
        this.router = router;
        this.localSt = localSt;
        this.showErrorMsg = false;
        this.showLoader = false;
        this.showEmailError = false;
    }
    loginComponent.prototype.ngOnInit = function () {
        this.createForm();
    };
    loginComponent.prototype.createForm = function () {
        this.loginForm = new FormGroup({
            email: new FormControl('', [Validators.required, Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]),
            password: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(20)]),
        });
    };
    loginComponent.prototype.closeModal = function () {
        this.activeModal.close();
    };
    loginComponent.prototype.loginFun = function () {
        var _this = this;
        this.showLoader = true;
        this.authAPIs.logIn(this.loginForm.value).subscribe(function (res) {
            _this.showLoader = false;
            if (res.statusCode === 200 && res.success === true) {
                _this.localSt.clear('zenUser');
                _this.localSt.store('zenUser', res.data);
                _this.activeModal.close();
                _this.router.navigate(['/']);
            }
            else if (res.statusCode === 105 && res.success === false) {
                _this.showErrorMsg = true;
            }
            else {
                // console.log(res.message);
            }
        }, function (error) {
            _this.showLoader = false;
            if (error.status === 400) {
                _this.showErrorMsg = true;
            }
        });
    };
    loginComponent.prototype.forgotPwdModal = function () {
        this.activeModal.close();
        this.modalService.open(forgotPwdComponent, { backdrop: 'static', keyboard: false });
    };
    loginComponent.prototype.openSignUpModal = function () {
        this.activeModal.close();
        this.modalService.open(signupComponent, { backdrop: 'static', keyboard: false });
    };
    loginComponent.prototype.emailValidation = function () {
        this.loginForm.controls.email.errors !== null ? this.showEmailError = true : this.showEmailError = false;
    };
    return loginComponent;
}());
export { loginComponent };



// WEBPACK FOOTER //
// ./src/app/modules/user/auth/login/login.component.ts.pre-build-optimizer.js